/** Чи назва типу запису стоїть у множині — для підпису «Усі {name}» («Усі ризики», але «Усі записи» для «База знань»). */
import type { Lang } from '@platform/core/types';

/** Прийменники й сполучники, що відокремлюють головне слово англійської назви від залежних («Questions to the Government»). */
const EN_TAIL = /\s+(?:of|to|on|for|in|with|by|from|about|at|per|and|or|&)\s+/i;

/**
 * Англійська назва в множині: головне слово (останнє перед прийменником, без дужок) закінчується на -s, але не на -ss, -us, -is
 * («Risks», «Follow-ups», «Comments on text» — так; «Factor analysis», «Business», «Status» — ні); абревіатура з -s («KPIs») — так. Чиста функція.
 */
export function isEnglishPlural(name: string): boolean {
  const head = name.replace(/\([^)]*\)/g, ' ').split(EN_TAIL)[0]?.trim() ?? '';
  const word = head.split(/\s+/).pop() ?? '';
  if (/^[A-Z0-9]{2,}s$/.test(word)) return true;
  return /s$/i.test(word) && !/(?:ss|us|is)$/i.test(word);
}

/**
 * Назва типу `name` мовою `lang` — множина? Англійська — за її головним словом (isEnglishPlural). Українська — за закінченням першого слова:
 * -и/-і/-ї — множина («Ризики», «Позиційні документи»); -а/-я/-ю неоднозначні («Завдання», «Слухання» — множина, «База знань», «Навчання» —
 * однина), тож вирішує англійська назва типу `englishName` (без неї — однина); решта (приголосний, -о, -й…) — однина («Форсайт», «Майно»).
 * Назва без кирилиці (абревіатура) — за англійською. Чиста функція.
 */
export function isPluralName(name: string, englishName: string | null | undefined, lang: Lang): boolean {
  if (lang === 'en') return isEnglishPlural(name);
  const english = englishName ? isEnglishPlural(englishName) : false;
  const first = (name.trim().split(/\s+/)[0] ?? '').replace(/[^\p{L}’'-]/gu, '').toLocaleLowerCase('uk-UA');
  if (!/[а-яіїєґ]/.test(first)) return english;
  if (/[иії]$/.test(first)) return true;
  return /[аяю]$/.test(first) && english;
}
